import { reactive } from 'vue'

const state = reactive({
  src: false,
})

function openOverlay(src) {
  state.src = src
}

function closeOverlay() {
  state.src = false
}

export default function useImageLightBox() {
  return {
    state,
    openOverlay,
    closeOverlay,
  }
}
